import * as React from 'react';
import { Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Page } from 'components/Layout';
import { LabeledData } from 'components/Input';
import { CircularLoader } from 'components/Loader';
import { formatDollar } from 'helpers/formatters';
import { UnderwriterReview } from 'types/underwriting.type';
import { withStyles } from '@mui/styles';
import { AmType } from '../../../../types/types.type';
import { useSelector } from 'react-redux';
import { getProductLineTypesByCode } from '../../../../application/redux/selectors';
import { calculateAdditionalBrokerPremium } from '../../../../helpers/calculations';
import { getProductLineDisplayValue } from '../../../../helpers/submissions';

interface Props {
    title?: string;
    uwFees: UnderwriterReview[];
}

const NoBorderCell = withStyles({
    root: {
        borderBottom: 'none',
    },
})(TableCell);

const BorderBottomCell = withStyles({
    root: {
        borderBottom: '1px solid',
    },
})(TableCell);

const TaxesAndFeesPage: React.FunctionComponent<Props> = (props) => {
    const { title, uwFees } = props;

    const productLineTypes: Record<string, AmType> = useSelector(getProductLineTypesByCode);

    const calculateTotalCost = (review: UnderwriterReview) =>
        calculateAdditionalBrokerPremium(
            review.isBrokerCommissionRated,
            review.premium,
            review.brokerCommissionPercentage
        ) +
        review.inspectionFee +
        review.professionalFee +
        review.policyFee +
        review.slaTax +
        review.slaFee;

    const generateRow = (dataLabel: string, data: number, bottomBorder?: boolean) => {
        return (
            <TableRow>
                <NoBorderCell align={'left'}>
                    <Typography variant={'h4'}>{`${dataLabel}:`}</Typography>
                </NoBorderCell>
                {!bottomBorder && (
                    <NoBorderCell align={'left'}>
                        <Typography>{formatDollar(data)}</Typography>
                    </NoBorderCell>
                )}
                {bottomBorder && (
                    <BorderBottomCell align={'left'}>
                        <Typography>{formatDollar(data)}</Typography>
                    </BorderBottomCell>
                )}
            </TableRow>
        );
    };

    if (!uwFees) return <CircularLoader fillHeight="30vh" />;

    return (
        <Page title={title || 'Taxes and Fees Review'}>
            <Grid container spacing={2}>
                {uwFees.map((review) => (
                    <Grid xs={6}>
                        <Typography variant={'h5'}>{`${getProductLineDisplayValue(
                            productLineTypes,
                            review.productLineTypeCode
                        )} (${review.homeState})`}</Typography>
                        <Table size={'small'}>
                            <TableBody>
                                {generateRow(
                                    'Gross Premium',
                                    calculateAdditionalBrokerPremium(
                                        review.isBrokerCommissionRated,
                                        review.premium,
                                        review.brokerCommissionPercentage
                                    )
                                )}
                                {generateRow('Inspection Fee', review.inspectionFee)}
                                {generateRow('Policy Fee', review.policyFee)}
                                {review.professionalFee !== 0 &&
                                    generateRow('Professional Fee', review.professionalFee)}
                                {generateRow('State Tax', review.slaTax)}
                                {generateRow('Stamping Fee', review.slaFee, true)}
                                {generateRow('Total Cost', calculateTotalCost(review))}
                            </TableBody>
                        </Table>
                    </Grid>
                ))}
                {/*<Grid xs={6}>*/}
                {/*    <LabeledData title="Home State" value={uwFees.homeState} />*/}
                {/*</Grid>*/}
            </Grid>
        </Page>
    );
};

export default TaxesAndFeesPage;
